@for (category of mainCategories; track category) {
  <div>
    <button style="direction: rtl; text-align: right;" mat-menu-item >
      <span (click)="changeCategory($event)">{{category.name}}</span>
      @if (category.hasSubCategory) {
        <span>
          @if (opened[category.id]) {
            <mat-icon (click)="closeMenu(category.id)" >keyboard_arrow_down</mat-icon>
          }
          @if (!opened[category.id]) {
            <mat-icon (click)="openMenu(category.id)" >keyboard_arrow_left</mat-icon>
          }
        </span>
      }
    </button>
    @if (category.hasSubCategory && opened[category.id]) {
      <div class="sub-category">
        <app-category-list [categories]="categories" [categoryParentId]="category.id" (change)="changeCategory($event)"></app-category-list>
      </div>
    }
  </div>
}
